<template>
  <canvas height="325" ref="totalStats"></canvas>
</template>

<script>
import { mapGetters } from "vuex";
import Chart from "chart.js";

export default {
  name: "TotalStats",
  data() {
    return {
      chart: {
        labels: [
          this.$t("VUE.CHART.PROCESSED"),
          this.$t("VUE.CHART.PENDING"),
          this.$t("VUE.CHART.REJECTED"),
          this.$t("VUE.CHART.ONCHECK"),
          this.$t("VUE.CHART.HELPCONFIRMED")
        ],
        backgroundColor: [
          "rgba(51, 102, 204, .9)",
          "rgba(220, 57, 18, .9)",
          "rgba(255, 153, 0, .9)",
          "rgba(16, 150, 24, .9)",
          "rgba(153, 0, 153, .9)"
        ],
        borderWidth: 0,
        options: {
          maintainAspectRatio: false,
          legend: {
            display: false
          }
        }
      }
    };
  },
  computed: mapGetters(["chartData"]),
  mounted() {
    Chart.defaults.global.defaultFontFamily = "'Nunito', sans-serif";
    new Chart(this.$refs.totalStats, {
      type: "pie",
      data: {
        labels: this.chart.labels,
        datasets: [
          {
            data: this.chartData,
            backgroundColor: this.chart.backgroundColor,
            borderWidth: this.chart.borderWidth
          }
        ]
      },
      options: {
        maintainAspectRatio: false,
        legend: {
          display: false
        }
      }
    });
  },
  beforeDestroy() {
    Chart && Chart.destroy ? Chart.destroy() : null;
  }
};
</script>
